import React, { SVGProps } from "react";
export default function SupChevronLineLeft(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1799 12L9.71898 12.3841L10.1799 12.7682L16.1799 17.7682L16.8201 17L11.281 12.3841L16.8201 7.76822L16.1799 7L10.1799 12ZM8 7.38411V17.3841H9V7.38411H8Z"
        fill="currentColor"
      />
    </svg>
  );
}
